import React from "react";
import { useNavigate } from "react-router-dom";


const Resultpopup =({ onSave, onLeave, onCancel })=>{
    const navigate = useNavigate();
    return(
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm p-4">
              <div className="bg-white p-6 sm:p-8 md:p-10 rounded-3xl shadow-lg w-11/12 max-w-3xl aspect-[16/9] min-h-[30rem] sm:min-h-[15rem] max-h-[10vh] flex flex-col justify-center relative">
                <div className="flex flex-col items-center justify-center text-center">
                  <p className="text-sm sm:text-base font-medium tracking-wide mt-2 mb-6 sm:mb-8" style={{ fontFamily: "sans-serif, Archivo" }}>
                  You have unsaved changes. Do you want to leave?
                  </p>
                  
                  <button className="w-[70%] sm:w-[40%] md:w-[40%] lg:w-[32%] h-auto flex items-center justify-center bg-[#2563EB] 
                    text-base sm:text-base lg:text-lg md:text-xl font-bold text-white py-1 sm:py-3 md:py-2 lg:py-1 px-1 ps-5 sm:px-6 md:px-2 md:ps-9 lg:px-1 lg:ps-4 rounded-full"
                    onClick={onSave}>
                    Save
                    
                  </button>
                  <button className="w-[70%] sm:w-[40%] md:w-[40%] lg:w-[32%] h-auto flex items-center justify-center bg-[#2563EB] 
                    text-base sm:text-base lg:text-lg md:text-xl font-bold text-white py-1 sm:py-3 md:py-2 lg:py-1 px-1 ps-5 sm:px-6 md:px-2 md:ps-9 lg:px-1 lg:ps-4 rounded-full"
                    onClick={onLeave}>
                    Cancel
                    
                  </button>
                </div>
              </div>
            </div>
    )
}

export default Resultpopup;